import { render, staticRenderFns } from "./DocumentCamera.vue?vue&type=template&id=ca3ba422&"
import script from "./DocumentCamera.js?vue&type=script&lang=js&"
export * from "./DocumentCamera.js?vue&type=script&lang=js&"
import style0 from "./DocumentCamera.vue?vue&type=style&index=0&id=ca3ba422&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports